import type { FC } from "react";

import {
  BASE_CARD_DEFAULTS,
  CARD_LAYOUT_CLASS_MAP,
  CARD_LAYOUT_CONTENT_CLASS_MAP,
  CARD_ORIENTATION_CLASS_MAP,
  TBaseCardProps,
} from "@/ui/components/data-display/Card/Card.config";
import { cn } from "@/ui/lib/utils";
import { CardImage } from "@/ui/components/data-display/Card/CardImage";

export const BaseCard: FC<TBaseCardProps> = (
  {
    image,
    ratio,
    children,
    className,
    "data-component": component = BASE_CARD_DEFAULTS["data-component"],
    layout = BASE_CARD_DEFAULTS.layout,
    orientation = BASE_CARD_DEFAULTS.orientation,
    tags,
    ...props
  },
) => (
  <article
    data-component={component}
    className={cn(
      "flex rounded-sys-sm border border-solid border-component-card-base",
      CARD_LAYOUT_CLASS_MAP[layout],
      CARD_ORIENTATION_CLASS_MAP[layout][orientation],
      className,
    )}
    {...props}
  >
    <CardImage image={image} ratio={ratio} tags={tags} />
    <div
      className={cn(
        "flex flex-col border-solid border-component-card-base",
        CARD_LAYOUT_CONTENT_CLASS_MAP[layout][orientation],
      )}
    >
      { children }
    </div>
  </article>
);

BaseCard.displayName = "Card";
